import { Category, Item, Order } from '@reliance/types/models/Commissary';
import { IAuthToken } from '../models/auth';
import { IApiService, IPaginatedResponse } from '../services/api_service';

export const commissary = (centralApi: IApiService, getToken: () => IAuthToken) => ({
  category: {
    index: (params = ({} = null)): Promise<IPaginatedResponse<Category>> => {
      return centralApi.get('/commissary/category', { params });
    },
    post: (data = null) => {
      return centralApi.post('/commissary/category', data, {
        contentType: false
      });
    },
    put: async (id, data: FormData = null) => {
      if (data.get('categoryPhoto[0]')) {
        await centralApi.post(`/commissary/category/${id}/photo`, data, {
          contentType: false
        });
      }
      return centralApi.put(`/commissary/category/${id}`, {
        name: data.get('name')
      });
    }
  },
  item: {
    index: (params = ({} = null)): Promise<IPaginatedResponse<Item>> => {
      return centralApi.get('/commissary/item', { params });
    },
    post: (data = null) => {
      return centralApi.post('/commissary/item', data, {
        contentType: false
      });
    },
    put: async (id, data: FormData = null) => {
      if (data.get('itemPhoto[0]')) {
        await centralApi.post(`/commissary/item/${id}/photo`, data, {
          contentType: false
        });
      }
      return centralApi.put(`/commissary/item/${id}`, {
        name: data.get('name'),
        description: data.get('description'),
        price: data.get('price'),
        itemNumber: data.get('itemNumber'),
        billingCategory: data.get('billingCategory'),
        active: data.get('active')
      });
    }
  },
  order: {
    get: (id: number = null): Promise<Order> => {
      if (id == null) {
        return Promise.resolve(null);
      }
      return centralApi.get<Order>('/commissary/order/' + id);
    },
    index: (params = ({} = null)): Promise<IPaginatedResponse<Order>> => {
      return centralApi.get('/commissary/order', { params });
    },
    pdfUrl: (ids: string) => {
      return centralApi.buildUrl('/commissary/order.pdf', {
        ids,
        token: getToken().accessToken
      });
    }
  }
});
